import React from 'react'

function Conditional({condition, children}) {
    if (condition)
        return children
    else
        return null
}

export default Conditional